// extracted by mini-css-extract-plugin
module.exports = {"tagBox":"style-module--tagBox--3Qy_x","tagLink":"style-module--tagLink--2XBu1"};